export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_HIDE = 'NOTIFICATIONS_HIDE';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_REMOVE_ALL = 'NOTIFICATIONS_REMOVE_ALL';
export const NOTIFICATIONS_HIDE_ALL = 'NOTIFICATIONS_HIDE_ALL';

export const LOAD_NOTIFICATIONS_START = 'LOAD_NOTIFICATIONS_START';
export const LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS';
export const LOAD_NOTIFICATIONS_FAILED = 'LOAD_NOTIFICATIONS_FAILED';
